<div class="rm-performance-dashboard" [style.height]="height">
    <div class="rm-performance-dashboard__header">
        <h2 class="rm-performance-dashboard__title">{{ title }}</h2>
    </div>

    @if (isLoading) {
        <div class="rm-performance-dashboard__loading">
            <app-loading-state
                [message]="'Loading manager performance data...'"
            ></app-loading-state>
        </div>
    } @else if (hasError) {
        <div class="rm-performance-dashboard__error">
            <p class="rm-performance-dashboard__error-text">{{ errorMessage }}</p>
        </div>
    } @else if (!rmPerformanceData.length) {
        <div class="rm-performance-dashboard__empty">
            <p class="rm-performance-dashboard__empty-text">
                No manager performance data available!!!
            </p>
        </div>
    } @else {
        <div class="rm-performance-dashboard__cards-container">
            @for (rm of rmPerformanceData; track rm.rmId) {
                <div class="rm-performance-dashboard__card">
                    <div class="rm-performance-dashboard__card-header">
                        <span class="rm-performance-dashboard__card-icon"
                            ><app-svg-icon name="person" size="sm"
                        /></span>
                        <h3 class="rm-performance-dashboard__card-name">
                            {{ rm.rmName | titlecase }}
                        </h3>
                    </div>

                    <div class="rm-performance-dashboard__card-metrics">
                        <div class="rm-performance-dashboard__metric">
                            <div
                                class="rm-performance-dashboard__metric-value rm-performance-dashboard__metric-value--leads"
                            >
                                {{ rm.leads }}
                            </div>
                            <div class="rm-performance-dashboard__metric-label">Leads</div>
                        </div>

                        <div class="rm-performance-dashboard__metric">
                            <div
                                class="rm-performance-dashboard__metric-value rm-performance-dashboard__metric-value--pipeline"
                            >
                                {{ rm.pipeline }}
                            </div>
                            <div class="rm-performance-dashboard__metric-label">Pipeline</div>
                        </div>

                        <div class="rm-performance-dashboard__metric">
                            <div
                                class="rm-performance-dashboard__metric-value rm-performance-dashboard__metric-value--won"
                            >
                                {{ rm.won }}
                            </div>
                            <div class="rm-performance-dashboard__metric-label">Won</div>
                        </div>
                    </div>

                    <div class="rm-performance-dashboard__card-footer">
                        <span class="rm-performance-dashboard__conversion-label">Conversion %</span>
                        <div class="rm-performance-dashboard__conversion-progress">
                            <div
                                class="rm-performance-dashboard__progress-bar rm-performance-dashboard__progress-bar--{{
                                    getAchievementColorClass(rm.conversionPercentage)
                                }}"
                                [style.width.%]="getProgressBarWidth(rm.conversionPercentage)"
                            ></div>
                        </div>
                        <span
                            class="rm-performance-dashboard__conversion-value rm-performance-dashboard__conversion-value--{{
                                getAchievementColorClass(rm.conversionPercentage)
                            }}"
                            >{{ rm.conversionPercentage }}%</span
                        >
                    </div>
                </div>
            }
        </div>
    }
</div>
